import React from 'react'

import { FiGlobe, FiChevronDown } from 'react-icons/fi'

import style from './InternationalSiteButton.module.scss'

import HoverMenu from '~components/HoverMenu'

import INTERNATIONAL_SITES from '~models/InternationalSites'

const InternationalSiteButton = () => (
  <div className={style.button}>
    <span><FiGlobe /><FiChevronDown /></span>
    <HoverMenu>
      <ul>
        { INTERNATIONAL_SITES.map((site, index) => (
          <li key={index}>
            <a href={site.url}>{ site.name }</a>
          </li>
        ))}
      </ul>
    </HoverMenu>
  </div>
)

export default InternationalSiteButton